import ls from "localstorage-slim";

const save = (name: any, value: any) => ls.set(name, value);

const remove = (name: any) => ls.remove(name);

const get = (name: any) => ls.get(name);

export { save as saveSession, remove as removeSession, get as getSession };
